
import styled from 'styled-components'
import { device } from '../responsive'


export const Container = styled.div`
    padding: 100px 0px;
    background-color: rgba(47,46,65);
    width: 100%;
    position: relative;
`

export const Title = styled.h2`
    text-align: center;
    font-size: 29px;
    font-weight: 600;
    margin-top: 0rem;
    margin-bottom: 1rem;
    color: #ffffff;
    @media screen and ${device.mobile} {
        font-size: 20px;
        
    }
`
export const Hr = styled.div`
    margin: auto;
    width: 40px;
    height: 3px;
    background-color: #FFFFFF;
    margin-bottom: 30px;
`

export const Desc = styled.p`
    color: #ffffff;
    font-size: 18px;
    width: 600px;
    margin: auto;
    line-height: 30px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 50px;

    @media screen and ${device.tablet} {
        width: 400px;
        
    }
    @media screen and ${device.mobile} {
        font-size: 0.9rem;
        width: 300px;
        line-height: 27px;
    }
`
export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 600px;
    margin: auto;   

    @media screen and ${device.mobile} {
        width: 80%;
    }
    @media screen and ${device.xsmobile} {
        width: 90%;
    }
`
export const Label = styled.label`
position: absolute;
left: -9999px;
width: 1px;
height: 1px;
padding: 0;
margin: -1px;
overflow: hidden;
clip: rect(0 0 0 0);
white-space: nowrap;
border: 0;
color: #ffffff;
`

export const Input = styled.input`
    padding: 15px 10px;
    margin-bottom: 15px;
    background-color: rgba(0,0,0,0.4);
    border: none;
    color: #fff;
    font-size: 0.9rem;
`

export const Textarea = styled.textarea`
    padding: 10px;
    margin-bottom: 10px;
    background-color: rgba(0,0,0,0.4);
    border: none;
    color: #fff;
    font-size: 0.9rem;
`
export const Button = styled.button`
    padding: 12px 10px;
    cursor: pointer;
    border-radius: 15px;
    font-size: 1rem;
    font-weight: 700;
    width: 35%;
    display: block;
    margin: 30px auto 0px;
    transition: all 0.3s ease-in-out;
    // text-transform: uppercase;
    background-color: teal;
        color: #fff;
        border: 1px solid teal;
        &:hover {
            background-color: #5BA5A5;
        }

    @media screen and ${device.mobile} {
       width: 40%;
       font-size: 0.8rem;
    }
`